import axios from "axios";
import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { api_raiz } from "../../config/config";

// Debe coincidir con MAX_DIAS_RANGO del backend (GpsRecuperacionReporteService)
export const MAX_DIAS_RANGO = 31;

export const columnas = [
  { columna: "idGps", label: "ID GPS" },
  { columna: "imei", label: "IMEI" },
  { columna: "nombreGps", label: "NOMBRE GPS" },
  { columna: "plataforma", label: "PLATAFORMA" },
  { columna: "transporteCorto", label: "TRANSPORTISTA" },
  { columna: "localidadColocacion", label: "LOCALIDAD COLOCACIÓN" },
  { columna: "deviceactivity", label: "ÚLTIMA ACTIVIDAD" },
  { columna: "fechaRecuperacion", label: "FECHA RECUPERACIÓN" },
  { columna: "usuarioRecupero", label: "USUARIO RECUPERÓ" },
  { columna: "localidadRecuperacion", label: "LOCALIDAD RECUPERACIÓN" },
  { columna: "diasDesdeRecuperacion", label: "DÍAS DESDE RECUPERACIÓN" },
];

// Regresa el mensaje de error o null si el rango es válido
export const validarRango = (fechaInicio, fechaFin) => {
  if (!fechaInicio || !fechaFin) {
    return "Selecciona fecha inicio y fecha fin";
  }
  const inicio = moment(fechaInicio, "YYYY-MM-DD");
  const fin = moment(fechaFin, "YYYY-MM-DD");
  if (fin.isBefore(inicio)) {
    return "La fecha fin no puede ser menor a la fecha inicio";
  }
  if (fin.diff(inicio, "days") > MAX_DIAS_RANGO) {
    return "El rango de fechas no puede ser mayor a " + MAX_DIAS_RANGO + " días";
  }
  return null;
};

export const consultarRecuperaciones = async (fechaInicio, fechaFin) => {
  const response = await axios.get(api_raiz + "gps_recuperaciones/reporte", {
    headers: { Authorization: "Bearer " + sessionStorage.getItem("tok") },
    params: { fechaInicio, fechaFin },
  });
  return response.data && response.data.data ? response.data.data : [];
};

export const mensajeError = (err) =>
  err.response && err.response.data && err.response.data.message
    ? err.response.data.message
    : "Error al consultar el reporte de recuperaciones";

export const exportarRecuperacionesExcel = (recuperaciones, fechaInicio, fechaFin) => {
  const filas = recuperaciones.map((r) => {
    const fila = {};
    columnas.forEach((c) => {
      fila[c.label] = r[c.columna];
    });
    return fila;
  });
  const ws = XLSX.utils.json_to_sheet(filas);
  const wb = { Sheets: { recuperaciones: ws }, SheetNames: ["recuperaciones"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  FileSaver.saveAs(blob, "recuperaciones_gps_" + fechaInicio + "_" + fechaFin + ".xlsx");
};
